import './mt-subscription-box.styles.scss';
import { Button } from '@mui/material';

const MtSubscriptionBox = ({subscription}) => {
    const { header, title, price, installmentsNumber, advantages, logoUrl } = subscription;
    return (
        <div className='mt-subscription-box-container'>
            <span className='header'>{header}</span>
            <h1 className='title'>{title}</h1>
            <h1 className='price'>R$ {price}</h1>
            <span className='sub-price'>ou {installmentsNumber}x de R$ {(price / installmentsNumber).toFixed(2)}</span>
            <div className='horizontal-divisor'/>
            {advantages.map(advantage => (
                <span className='advantage'>{advantage}</span>
            ))}
            <img className='partner-logo' src={logoUrl}/>
            <Button className='action' variant='contained' size='small'>Selecionar esse plano</Button>
        </div>
    )
}

export default MtSubscriptionBox;